import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

import {SurveyService} from './../../surveys.service';
import {ListSurveyLanguageHashModel, SurveyCreatePDModel, SurveyTabs} from './../../../../models/survey/survey.model';
import {environment} from './../../../../../environments/environment';
import {DxDateBoxComponent} from 'devextreme-angular';
import {ToasterService} from 'angular5-toaster/dist';
import {AuthTokenService} from '../../../../shared/services/auth-token.service';

@Component({
  selector: 'app-review-tab',
  templateUrl: './review-tab.component.html',
  styleUrls: ['./review-tab.component.less']
})
export class ReviewTabComponent implements OnInit {

  edit: boolean;
  date: string;
  info: boolean;
  currCalcVals: any;
  appUrl: string;
  showReviewLoader: boolean;
  statusList: { id: number, name: string }[];
  dropdown = false;
  isAdmin = AuthTokenService.isAdmin();

  @Output() tabToActivate = new EventEmitter<number>();
  @Output() surveyCreatePDModelChange = new EventEmitter<SurveyCreatePDModel>();
  @ViewChild('dxDate') dxDate: DxDateBoxComponent;

  constructor(public surveyService: SurveyService,
              private toasterService: ToasterService) {
  }

  ngOnInit() {

    this.edit = false;
    this.date = '11/12/2016';
    this.info = false;
    this.appUrl = environment.appUrl;

    this.currCalcVals = [];
    for (let c of this.surveyService.surveyCreatePDModel.listPeopleSurveyCurrencyModel) {
      this.currCalcVals.push({name: c.name, totalValue: c.value * c.peopleWithCurrCount});
    }

    if (this.surveyService.surveyCreatePDModel.dueDate == null)
      this.surveyService.surveyCreatePDModel.dueDate = new Date();

    this.statusList = [
      {id: 1, name: 'Pending'},
      {id: 2, name: 'Awaiting approval'},
      {id: 3, name: 'Published'},
      {id: 4, name: 'Closed incomplete'},
      {id: 5, name: 'Closed complete'}
    ];
  }

  save() {//ngOnDestroy() {
    if (!this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length) {
      this.toasterService.pop('error', 'Survey required min one question!');
      return;
    }
    this.surveyCreatePDModelChange.emit(this.surveyService.surveyCreatePDModel);
  }

  publishSurvey() {
    if (!this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length) {
      this.toasterService.pop('error', 'Survey required min one question!');
      return;
    }

    if (!this.surveyService.surveyCreatePDModel.dueDate) {
      this.toasterService.pop('error', 'Survey required due date!');
      return;
    }

    this.surveyService.surveyCreatePDModel.status = 3;

    this.showReviewLoader = true;
    this.surveyService.surveyCreatePDModel.tabId = SurveyTabs.Review;
    this.surveyService.save(this.surveyService.surveyCreatePDModel).subscribe(
      (response) => {
        this.surveyService.surveyCreatePDModel = response;
        this.showReviewLoader = false;
      },
      (error) => {
        // console.log(error);
        this.showReviewLoader = false;
      }
    );

  }

  onClickOutsideType(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  toggleDropdown() {
    if (this.isAdmin) {
      this.dropdown = !this.dropdown;
    }
  }

  getStatusName(status) {
    return this.statusList.find(a => a.id == status).name;
  }

  // ivan todo change statuses
  changeSurveyStatus(status) {
    if (!this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length && status != 1) {
      this.toasterService.pop('error', 'Survey required min one question!');
      return;
    }

    if (!this.surveyService.surveyCreatePDModel.dueDate) {
      this.toasterService.pop('error', 'Survey required due date!');
      return;
    }

    if (this.surveyService.surveyCreatePDModel.status > 2 && status < 3) {
      this.toasterService.pop('error', 'Published Survey can\'t be changed to pending!');
      return;
    }


    this.surveyService.surveyCreatePDModel.status = status;
    this.showReviewLoader = true;
    this.surveyService.surveyCreatePDModel.tabId = SurveyTabs.Review;
    this.surveyService.save(this.surveyService.surveyCreatePDModel).subscribe(
      (response) => {
        this.surveyService.surveyCreatePDModel = response;
        this.showReviewLoader = false;
      },
      (error) => {
        // console.log(error);
        this.showReviewLoader = false;
      }
    );

  }

  toggleEdit() {
    if (this.isAdmin) {
      this.edit = !this.edit;
      if (this.edit === false) {
        this.surveyCreatePDModelChange.emit(this.surveyService.surveyCreatePDModel);
      }
    }
  }

  showInfo() {
    this.info = true;
  }

  onKeyUpCurr(e, c) {
    this.currCalcVals.find(a => a.name === c.name).totalValue = e.target.value * c.peopleWithCurrCount;
    this.surveyService.surveyCreatePDModel.listPeopleSurveyCurrencyModel.find(a => a.name === c.name).value = e.target.value;
  }

  changeTabLocal(index) {
    this.tabToActivate.emit(index);
  }

  showPreview() {

    if (!this.surveyService.surveyCreatePDModel.listSurveyQuestionModel.length) {
      this.toasterService.pop('error', 'Survey required min one question!');
      return;
    }

    let url = this.appUrl + this.surveyService.surveyCreatePDModel.listSurveyLanguageHashModel[0].surveyHash;
    window.open(url, '_blank');
    // window.open(url);
  }

  getSurveyVersionLabel(surveyVersion: ListSurveyLanguageHashModel): string {
    return surveyVersion.versionName ? surveyVersion.versionName : 'Survey ' + surveyVersion.languageName + ' URL';
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/review-tab/review-tab.component.ts